export default "__VITE_ASSET__898fSSDa__"